import { z } from 'zod';
import { payableDataSchema } from '../../Payable.js';
import { externalTaxServiceConfigSchema } from '../configurations/ExternalTaxServiceConfig.js';
import { servicesProviderGenericDataSchema } from '../ServicesProviderData.js';
import { Services } from './Services.js';

const servicesProviderExternalTaxDataSchema = servicesProviderGenericDataSchema
    .merge(payableDataSchema)
    .extend({
    config: z.object({
        [Services.EXTERNAL_TAX]: externalTaxServiceConfigSchema,
    }),
});

export { servicesProviderExternalTaxDataSchema };
//# sourceMappingURL=ServicesProviderExternalTaxData.js.map
